const availableHairColors = [
    {
        color: 'Preto',
        code: 'black'
    },
    {
        color: 'Castanho',
        code: 'brown'
    },
    {
        color: 'Ruivo',
        code: 'redhead'
    },
    {
        color: 'Loiro',
        code: 'blonde'
    },
    {
        color: 'Cabelos Coloridos',
        code: 'dyed'
    }
]

export default availableHairColors
